function Q3OperatingResults2025() {
	return (
		<div className="not-prose">
			<div className="overflow-x-auto">
				<table className="min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<thead>
						<tr>
							<th colSpan={5}>
								<span className="block mb-2 text-right text-[0.75rem] text-black">($ in billions)</span>
							</th>
						</tr>
						<tr className="text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td></td>
							<th colSpan={3} className="align-bottom border-none">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">Commercial Lines Business</th>
						</tr>
						<tr className="text-right no-hover text-[#4B7B9D]">
							<td></td>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Vehicles</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Property</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Total</th>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Written</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="no-hover">Nine Months Ended September 30,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>
								<span className="float-left">$</span>52.7
							</td>
							<td>
								<span className="float-left">$</span>2.4
							</td>
							<td>
								<span className="float-left">$</span>55.1
							</td>
							<td>
								<span className="float-left">$</span>8.5
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>45.3</td>
							<td>2.4</td>
							<td>47.7</td>
							<td>8.6</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>16%</td>
							<td>2%</td>
							<td>16%</td>
							<td>(1)%</td>
						</tr>

						<tr>
							<td colSpan={5} className="py-4"></td>
						</tr>

						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Earned</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="no-hover">Nine Months Ended September 30,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>
								<span className="float-left">$</span>50.0
							</td>
							<td>
								<span className="float-left">$</span>2.3
							</td>
							<td>
								<span className="float-left">$</span>52.3
							</td>
							<td>
								<span className="float-left">$</span>8.2
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>41.5</td>
							<td>2.2</td>
							<td>43.7</td>
							<td>7.9</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>20%</td>
							<td>6%</td>
							<td>20%</td>
							<td>3%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						<tr>
							<th className="font-bold font-trade text-[#767727] no-hover">Policies in Force</th>
							<th></th>
							<th></th>
							<th></th>
							<th className="text-[0.75rem] font-trade !pr-0 !border-r-0">
								<span className="block mb-2 text-[0.75rem] text-right text-black">(# in thousands)</span>
							</th>
						</tr>
						<tr>
							<td className="no-hover">September 30,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>33,229</td>
							<td>3,651</td>
							<td>36,880</td>
							<td>1,198</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>29,278</td>
							<td>3,460</td>
							<td>32,738</td>
							<td>1,131</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>13%</td>
							<td>6%</td>
							<td>13%</td>
							<td>6%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						{/* <tr className="no-hover text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<th className="align-bottom border-none">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">Commercial Lines Business</th>
						</tr> */}
						<tr>
							<td className="font-bold font-trade text-[#767727] ">Underwriting Ratios</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<th className="align-bottom border-none text-center no-hover text-[#4B7B9D] leading-[140%]">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none text-center no-hover text-[#4B7B9D] leading-[140%]">Commercial Lines Business</th>
						</tr>
						<tr>
							<td className="no-hover">Nine Months Ended September 30,</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
						<tr>
							<td className="cell-indent" colSpan={2}>
								Loss and loss adjustment expense ratio – 2025
							</td>

							<td className="!border-r-0"></td>
							<td>65.3</td>
							<td>67.3</td>
						</tr>
						<tr>
							<td className="cell-indent" colSpan={2}>
								Underwriting expense ratio – 2025<sup>1</sup>
							</td>
							<td className="!border-r-0"></td>

							<td className="border-b-[1px] border-[#BFBFBF]">21.8</td>
							<td className="border-b-[1px] border-[#BFBFBF]">20.5</td>
						</tr>
						<tr>
							<td className="cell-indent--2">
								Combined ratio – 2025<sup>1</sup>
							</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td>87.1</td>
							<td>87.8</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2024</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td>89.0</td>
							<td>89.7</td>
						</tr>
						<tr>
							<td className="cell-indent--3" colSpan={2}>
								Change over prior period
							</td>
							<td className="!border-r-0"></td>
							<td>(1.9) pts.</td>
							<td>(1.9) pts.</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div className="text-[.85rem] leading-[1.6] tabular-nums">
				<div className="flex gap-2">
					<span>
						<sup>1</sup>
					</span>
					<p className="mb-0 no-animate">For the nine months ended September 30, 2025, included in both the underwriting expense and the combined ratios in the Personal Lines business are 1.8 points of expense related to Florida policyholder credit expense.</p>
				</div>
			</div>
		</div>
	);
}

export default Q3OperatingResults2025;
